import React from 'react';

const steps = [
  {
    icon: '⚾',
    title: 'Start a Game',
    desc: 'The umpire or a volunteer opens UmpBuddy and taps "Start a Game". Enter team names and set your game rules — innings, mercy rules, time limit, and more.',
  },
  {
    icon: '🔑',
    title: 'Share the Code',
    desc: 'A unique 6-character game code is generated. Share it with the crowd — yell it out, text it in the group chat, whatever works.',
  },
  {
    icon: '📱',
    title: 'Spectators Join',
    desc: 'Anyone can go to umpbuddy.com, tap "Join as Spectator", enter the code, and instantly see the live score — no account, no app download required.',
  },
  {
    icon: '📡',
    title: 'Follow Along Live',
    desc: 'Every pitch, out, and run updates instantly for every spectator. No more asking "what\'s the score?" — just check your phone.',
  },
  {
    icon: '📲',
    title: 'Install the App',
    desc: 'For the best experience, add UmpBuddy to your home screen. On iPhone: tap Share → "Add to Home Screen". On Android: tap the menu → "Add to Home Screen".',
  },
];

export default function HowTo({ navigate }) {
  return (
    <div className="screen">
      <div className="header">
        <button className="header-back" onClick={() => navigate('landing')}>‹</button>
        <span className="header-title">How It Works</span>
      </div>

      <div className="scroll-content" style={{ padding: '16px 24px' }}>
        <p style={{ color: 'var(--gray)', fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>
          UmpBuddy is designed for beer leagues, rec leagues, and any game without a scoreboard. One person tracks, everyone else follows live.
        </p>

        {steps.map((step, i) => (
          <div key={i} style={{
            display: 'flex',
            gap: 16,
            marginBottom: 24,
            background: 'var(--surface)',
            border: '2px solid var(--border)',
            borderRadius: 'var(--radius)',
            padding: '16px',
          }}>
            <div style={{ fontSize: 32, flexShrink: 0 }}>{step.icon}</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 4, color: 'var(--white)' }}>
                <span style={{ color: 'var(--green)', marginRight: 6 }}>{i + 1}.</span>{step.title}
              </div>
              <div style={{ fontSize: 14, color: 'var(--gray)', lineHeight: 1.6 }}>{step.desc}</div>
            </div>
          </div>
        ))}

        <button className="btn btn-primary btn-lg" onClick={() => navigate('app')} style={{ marginTop: 8 }}>
          ⚾ Open the App
        </button>
      </div>
    </div>
  );
}
